module.exports = __webpack_public_path__ + "media/images/authentication/registration-f70864bb4c16a10e2f797d95e152730b.png";